import { http } from "../config/HttpMethod";
import { WellDetailsPayload } from "../store/model/calculations/calculation";
import { ESP_ENDPOINTS } from "./calculations/endpoints";

export const getCountry = async () => {
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_STATES_BY_COUNTRY}`);
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const getCounty = async (payload: string) => {
    const params = {
        stateID: payload
    };
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_COUNTY_LIST}`, { params });
        return response?.data;
       
    } catch (err) {
        console.log(err, 'error');
    }
};

export const getState = async (payload: string) => {
    const params = {
        State: payload
    };
    try {

        const response = await http.get(`${ESP_ENDPOINTS?.GET_COUNTRY_BY_STATE}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};


export const getWellDetails = async (payload: WellDetailsPayload) => {
    try {
        const response = await http.post(`${ESP_ENDPOINTS?.GET_WELL_DETAILS}`, payload);
        return response?.data?.data ?? response?.data;
    } catch (err) {
        console.log(err, "error");
    }
};

export const getWellDetailsById = async (payload: number) => {
    const params = {
        Id: payload
    }
    try {

        const response = await http.get(`${ESP_ENDPOINTS?.GET_WELLS_BY_ID}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err, "error");
    }
};

export const getCustomerById = async (payload: number) => {
    const params = {
        Id: payload
    }
    try {
        const response = await http.get<number>(`${ESP_ENDPOINTS?.GET_CUSTOMER_BY_ID}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err, "error");
    }
};

export const getAccountManager = async () => {
    try {
        const response = await http.get<number>(`${ESP_ENDPOINTS?.GET_ACCOUNT_MANAGERS}`);
        return response?.data;
    } catch (err) {
        console.log(err, "error");
    }
};